export default __webpack_public_path__ + "static/media/placeholder-image_trays.272269a3.svg";